import Layout from './Layout'
export default {
  path: '/:user_type(users|proprietaire|agent|manager)',
  component: Layout,
  children: [
    {
      path: 'account',
      name: 'DashboardAccount',
      component: () => import('./pages/profile/Account'),
      meta: {
        title: 'COOLOC | Mon compte',
      },
    },
    {
      path: 'profile',
      name: 'DashboardProfile',
      component: () => import('./pages/profile/index'),
      meta: {
        title: 'COOLOC | Mon profil',
      },
    },
    {
      path: 'home-matching',
      name: 'DashboardHomeMatching',
      component: () => import('./pages/home-matching/Coloc.vue'),
      meta: {
        title: 'COOLOC | Recherche de co-locations',
      },
    },
    {
      path: 'user-matching',
      name: 'DashboardUserMatching',
      alias: 'matching',
      component: () => import('./pages/user-matching/index.vue'),
      meta: {
        title: 'COOLOC | Recherche de co-locataires',
      },
    },
    {
      path: 'agenda',
      name: 'DashboardMeeting',
      component: () => import('./pages/agenda/index.vue'),
      meta: {
        title: 'COOLOC | Agenda',
      },
    },
    {
      path: 'favorites',
      component: () => import('./pages/favorites'),
      children: [
        {
          name: 'DashboardFavorites',
          path: '',
          meta: {
            title: 'COOLOC | Favoris',
          },
        },
        {
          name: 'DashboardFavoriteGroup',
          path: ':group_id',
          meta: {
            title: 'COOLOC | Groupe',
          },
        },
      ],
    },
    {
      path: 'messages',
      name: 'DashboardMessages',
      component: () => import('./pages/Messages'),
      meta: {
        title: 'COOLOC | Messagerie',
      },
    },
    {
      path: 'customer-service/:discussion_type?/:discussion_id?',
      name: 'DashboardCustomerService',
      component: () => import('./pages/CustomerService.vue'),
      meta: {
        title: 'COOLOC | Service client',
      },
    },
    {
      path: 'conciergerie',
      name: 'DashboardManagerSupport',
      component: () => import('./pages/support/DashboardManagerSupport.vue'),
      meta: {
        title: 'COOLOC | Conciergerie',
      },
    },
    {
      path: 'support',
      name: 'DashboardSupport',
      component: () => import('./pages/support/DashboardSupport.vue'),
      meta: {
        title: 'COOLOC | Support',
      },
    },
    {
      path: 'tenants-support',
      name: 'DashboardOwnerSupport',
      component: () => import('./pages/support/DashboardOwnerSupport.vue'),
      meta: {
        title: 'COOLOC | Demandes Locataires',
      },
    },
    {
      path: 'support/tickets/:ticket_id',
      name: 'DashboardSupportTicket',
      component: () => import('./pages/support/TicketDetails.vue'),
      meta: {
        title: 'COOLOC | Ticket',
      },
    },
    {
      path: 'tickets/:ticket_id',
      name: 'DashboardManagerSupportTicket',
      component: () => import('./pages/support/TicketDetails.vue'),
      meta: {
        title: 'COOLOC | Ticket',
      },
    },
    {
      path: 'search',
      name: 'DashboardSearch',
      component: () => import('./pages/Search'),
      meta: {
        title: 'COOLOC | Recherche',
      },
    },
    {
      path: 'parameters',
      name: 'DashboardParameters',
      component: () => import('./pages/Parameters'),
      meta: {
        title: 'COOLOC | Paramètres',
      },
    },
    {
      path: 'profile/edit',
      name: 'DashboardEdition',
      component: () => import('./pages/edition/index'),
      meta: {
        title: 'COOLOC | Edition de mon profil',
      },
    },
    {
      path: 'account/edit',
      name: 'DashboardAccountEdition',
      component: () => import('./pages/edition/Account'),
      meta: {
        title: 'COOLOC | Edition de mon compte',
      },
    },
    {
      path: 'biens',
      name: 'DashboardProHomes',
      component: () => import('./pages/ProHomes'),
      meta: {
        title: 'COOLOC | Mes biens',
      },
    },
    {
      path: 'gestion',
      name: 'DashboardProReports',
      component: () => import('./pages/ProReports'),
      meta: {
        title: 'COOLOC | Gestion',
      },
    },
    {
      path: 'abonnement',
      name: 'DashboardProSubscriptions',
      component: () => import('./pages/ProSubscriptions'),
      meta: {
        title: 'COOLOC | Mon bien',
      },
    },
    {
      path: 'annonce',
      name: 'DashboardProAdvert',
      component: () => import('./pages/ProAdvert'),
      meta: {
        title: 'COOLOC | Mon annonce',
      },
    },
    {
      path: 'diagnostics',
      name: 'DashboardProDiagnostics',
      component: () => import('./pages/ProDiagnostics'),
      meta: {
        title: 'COOLOC | Mes diagnostics',
      },
    },
    {
      path: 'documents',
      name: 'DashboardProDocuments',
      component: () => import('./pages/ProDocuments'),
      meta: {
        title: 'COOLOC | Mes documents',
      },
    },
    {
      path: 'invitation',
      name: 'DashboardProInvitation',
      component: () => import('./pages/ProInvitation'),
      meta: {
        title: 'COOLOC | Invitation',
      },
    },
    {
      path: 'demandes',
      name: 'DashboardProContactRequests',
      component: () => import('./pages/ProContactRequests'),
      meta: {
        title: 'COOLOC | Demandes',
      },
    },
    {
      path: 'bail',
      name: 'DashboardProLeaseContract',
      component: () => import('./pages/ProLeaseContract'),
      meta: {
        title: 'COOLOC | Bail',
      },
    },
    {
      path: 'abonnement/annulation',
      name: 'DashboardCancelSubscription',
      component: () => import('./pages/ProCancelSubscription'),
      meta: {
        title: 'COOLOC | Annuler un abonnement',
      },
    },
    {
      path: 'annonce/:home_id',
      name: 'DashboardViewAdvert',
      component: () => import('@/components/dashboard/pages/ViewAdvert'),
      meta: {
        title: 'COOLOC | Visualisation de l\'annonce',
      },
    },
    {
      path: 'preview-annonce',
      name: 'DashboardPreviewAdvert',
      component: () => import('./pages/PreviewAdvert'),
      meta: {
        title: 'COOLOC | Pré-visualisation de l\'annonce',
      },
    },
    {
      path: ':user_id/profile',
      name: 'UserProfile',
      component: () => import('./pages/PublicProfile'),
      meta: {
        title: 'COOLOC | Profil',
      },
    },
    {
      path: 'annonce-modification/:home_id',
      name: 'HomeEdit',
      component: () => import('./pages/HomeEdit'),
      meta: {
        title: 'COOLOC | Edition de mon annonce',
      },
    },
    {
      path: 'garantie',
      name: 'DashboardWarranty',
      component: () => import('./pages/Warranty'),
      meta: {
        title: 'COOLOC | Garantie',
      },
    },
    {
      path: 'ma-co-location',
      name: 'DashboardMyColocation',
      component: () => import('./pages/Colocation'),
      meta: {
        title: 'COOLOC | Ma co-location',
      },
    },
    {
      path: 'receipts',
      name: 'DashboardColocReceipts',
      component: () => import('./pages/coloc/TenantReceipts'),
      meta: {
        title: 'COOLOC | Quittances',
      },
    },
    {
      path: 'invoices',
      name: 'DashboardColocInvoices',
      component: () => import('./pages/coloc/TenantInvoices'),
      meta: {
        title: 'COOLOC | Factures',
      },
    },
    {
      path: 'documents',
      name: 'DashboardColocDocuments',
      component: () => import('./pages/coloc/TenantDocuments'),
      meta: {
        title: 'COOLOC | Documents',
      },
    },
    {
      path: 'my-next-cooloc',
      name: 'DashboardColocTenantApplicants',
      component: () => import('./pages/coloc/TenantApplicants.vue'),
      meta: {
        title: 'COOLOC | Mes Futurs Cooloc',
      },
    },
    {
      path: 'garantie/confirmer',
      name: 'WarrantyConfirm',
      component: () => import('./pages/warranty/WarrantyConfirm'),
      meta: {
        title: 'COOLOC | Garantie',
      },
    },
  ],
}
